var GrayAllFeaturesPanel = (function () {
  

  var $allFeaturesPanels = $('section.rzf-gry.rzf-gry-all-features-panel');

  var debounce;

  function init() {
    initLoop();
    resizeAll();
    _attachResize();
  }

  function initLoop() {

    $allFeaturesPanels.each(function (i, el) {

      // Set up divs to control heights.
      var $div1 = document.createElement('div');
      $div1.setAttribute('class', 'spacer-div-1');

      var $div2 = document.createElement('div');
      $div2.setAttribute('class', 'spacer-div-2');

      $(el).prepend($div2).prepend($div1);

      // Set up listeners
      initMutationObserver(el);

      // Add color theme to controls, if controls are present.
      var $controls = $('.rzf-gry-controls', $(el));
      if ($controls.length > 0) {
        var theme = $('div.rzf-gry-all-features-panel', $(el)).data('rzf-gry-arrow-skin') + '-theme';
        $controls.addClass(theme);
      }
    });

    $('.features', $allFeaturesPanels).addClass('clearfix');
  }

  function initMutationObserver(el) {
    // create an observer instance
    var mutationObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.target !== mutation.oldValue) {
          if ($(mutation.target).hasClass('active') && ($(el).is(':visible'))) {
            $(el).addClass('active');
            resizeOne(el);
          } else {
            $(el).removeClass('active');
          }
        }
      });
    });

    // configuration of the observer:
    var mutationObserverConfig = { attributes: true, attributeOldValue: true };

    // Observe parent.
    mutationObserver.observe($(el).parent()[0], mutationObserverConfig);
  }

  function resizeAll() {
    $allFeaturesPanels.each(function (i, el) {
      resizeOne(el);
    });
  }

  function resizeOne(el) {
    // If panel is visible and overflowing, set scroll bars on features section.
    if ($(el).is(':visible')) {
      var $featuresSection = $('.features', $(el));
      destroyJspPane($featuresSection);
      doOverflown(el);
    }
  }

  function destroyJspPane($featuresSection) {
    $featuresSection.removeClass('jsp-scrollable');
    var api = $featuresSection.jScrollPane().data('jsp');
    api.destroy();
    $featuresSection.height('auto');
  }

  function doOverflown(el) {
    var $el = $(el);

    var $titlesWrapper = $('.titles-wrapper', $el);
    var $features = $('.features', $el);

    var titlesWrapperHeight = parseInt($titlesWrapper.outerHeight(true), 10);
    var featuresHeight = parseInt($features.outerHeight(true), 10);
    var insideHeight = titlesWrapperHeight + featuresHeight;

    if (insideHeight > $el.height()) {
      var overflownHeight = $el.height() - titlesWrapperHeight; // height left for features.
      $features.height(overflownHeight).jScrollPane({
        autoReinitialise: true,
      }).addClass('jsp-scrollable');
    } else {
      destroyJspPane($features);
    }
  }

  // Setup resize event with debounce.
  function _attachResize() {
    $(window).on('resize', _onResize);
  }

  function _onResize(event) {
    clearTimeout(debounce);
    debounce = setTimeout(resizeAll, 250);
  }

  return {
    init: init,
  };

}());
